import React from "react";

function TopComponent() {
  return (
    <div className="top-bg" id="home">
      <div className="bg-overlay">
        <h1>An Efficient Step To Modernize Your Kitchen</h1>
        <hr className="hr" />
        <p>
          Authorised dealer of world no 1 kitchen chimney, elica & introlink
          moduler kitchen.
        </p>
        <button
          className="btn btn-custom"
          onClick={() => {
            window.open("https://wa.me/919933315325");
          }}
        >
          Contact Us
        </button>
      </div>
    </div>
  );
}

export default TopComponent;
